export const Global ={
    urlLocal:'http://localhost:3500/api/',
    urlRosario:'https://api.adminrelax.shop/api/',
    urlNarnia:'https://narnia.adminrelax.shop/api/',
    url:'https://api.adminrelax.shop/api/' 
 }